/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/statement';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ListStatementsRequest": {
                    "fields": {
                      "customerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListStatementsResponse": {
                    "fields": {
                      "statements": {
                        "type": ".squareup.sfs.external.models.Statement",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListStatementsRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListStatementsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListStatementsRequest @ squareup/sfs/external/services/statement/list_statements.proto at 9:1
 */
export const ListStatementsRequest = $root.lookupType('squareup.sfs.external.service.ListStatementsRequest');
fixType(ListStatementsRequest, {
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(ListStatementsRequest);
/**
 * SOURCE ListStatementsResponse @ squareup/sfs/external/services/statement/list_statements.proto at 16:1
 */
export const ListStatementsResponse = $root.lookupType('squareup.sfs.external.service.ListStatementsResponse');
fixType(ListStatementsResponse);
Builder.createAndAttachToType(ListStatementsResponse);